// Thin axios wrapper used by AppContext and components.
//
// Centralizes:
// - The base URL (passed in once at construction)
// - Auth-header injection on every request (so callers don't have to remember)
// - A consistent error-message extractor (response.data.error → response.data.message → err.message)
//
// Components that want retries should still wrap individual calls with axiosRetry from AppContext.
// This client doesn't auto-retry — retry policy is per-call (some calls should fail fast).

import axios from 'axios';

export const extractApiError = (err) =>
  err?.response?.data?.error ||
  err?.response?.data?.message ||
  err?.message ||
  'Request failed';

export const createApiClient = ({ baseURL, getAuthHeaders }) => {
  const request = (method, path, data, opts = {}) => {
    const authHeaders = (getAuthHeaders && getAuthHeaders()) || {};
    const headers = { ...authHeaders, ...(opts.headers || {}) };
    const { headers: _ignored, ...rest } = opts;
    return axios({ method, url: `${baseURL}${path}`, data, headers, ...rest });
  };

  return {
    get: (path, opts) => request('get', path, undefined, opts),
    post: (path, data, opts) => request('post', path, data, opts),
    put: (path, data, opts) => request('put', path, data, opts),
    request,
  };
};
